// extracted by mini-css-extract-plugin
export default {"richtextblock":"index-module__richtextblock--lr1cf"};